import React from "react";
import PropTypes from "prop-types";
import NoIndex from "../NoIndex";
import {markup} from "../../../utils/markup";

export default function ProductDescription({content}) {
  return (
    <NoIndex>
      <div dangerouslySetInnerHTML={markup(content.description)} />
    </NoIndex>
  );
}

ProductDescription.propTypes = {
  content: PropTypes.shape({
    description: PropTypes.string
  })
};
